import userApi from '@/api/user';

const state = {
    currentUser: null,
    preferences: {},
    permissions: [],
};

const actions = {
    async getCurrentUser({ commit }) {
        let user = await userApi.getCurrent();
        commit('UPDATE_CURRENT_USER', { user });
    },
    async updatePreferences({ commit }, { preferences }) {
        commit('UPDATE_PREFERENCES', { preferences });
        let user = await userApi.updatePreferences(preferences);
        // Disabling this to prevent issues with sync lag:
        // commit('UPDATE_CURRENT_USER', { user });
    },
    subscribe({ commit }) {
        Echo.private(`user.${Laravel.userId}`)
            .listen('Users.UserUpdated', (e) => commit('UPDATE_CURRENT_USER', { user: e.user }));
    },
};

const mutations = {
    UPDATE_CURRENT_USER(state, { user }) {
        state.currentUser = user;
        state.preferences = user.settings || {};
        state.permissions = user.all_permissions;
    },
    UPDATE_PREFERENCES(state, { preferences }) {
        state.preferences = Object.assign({}, state.preferences, preferences);
    },
};

export default {
    state,
    actions,
    mutations,
    namespaced: true,
};
